<template>
<div class="chapter">
<div class="inner_page">
<h2 class="part"><a id="page_38"></a><a id="page_39"></a>SPIRES AND GARGOYLES</h2>
<p class="pt"><span class="bold">1913–1917</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 15_Part3.vue?42a52cd0